import { ApiService } from "@core/api/api-service";
import {
	OnboardingGetStartedStep,
	OnboardingProgramQuickstartStep,
	OnboardingStatus,
	OnboardingStep,
	OnboardingSteps,
	OnboardingType,
} from "@domain/onboarding/onboarding";
import { dateFromDateDto } from "@utils/date-utils";

type OnboardingStepsDto<T> = {
	step: T;
	date: string;
}[];

type OnboardingStatusDto = {
	steps: {
		[OnboardingType.GET_STARTED]?: OnboardingStepsDto<OnboardingGetStartedStep>;
	[OnboardingType.PROGRAM_QUICKSTART]?: OnboardingStepsDto<OnboardingProgramQuickstartStep>;
	};
};

export class OnboardingService {
	constructor(private readonly apiService: ApiService) {}

	async getOnboardingsStatus(): Promise<OnboardingStatus> {
		const result = await this.apiService.get<OnboardingStatusDto>("/pts/me/onboarding/status");
		return OnboardingService.onboardingStatusFromDto(result.data);
	}

	async sendOnboardingStepFinished(type: OnboardingType, step: OnboardingStep): Promise<void> {
		await this.apiService.post(`/pts/me/onboarding/${type}/step`, { step });
	}

	private static onboardingStatusFromDto(onboardingStatusDto: OnboardingStatusDto): OnboardingStatus {
		return {
			[OnboardingType.GET_STARTED]: OnboardingService.onboardingStepsFromDto(
				onboardingStatusDto.steps[OnboardingType.GET_STARTED],
			),
			[OnboardingType.PROGRAM_QUICKSTART]: OnboardingService.onboardingStepsFromDto(
				onboardingStatusDto.steps[OnboardingType.PROGRAM_QUICKSTART],
			),
		};
	}

	private static onboardingStepsFromDto<T>(dto?: OnboardingStepsDto<T>): OnboardingSteps<T> {
		return dto?.map(step => ({ ...step, date: dateFromDateDto(step.date) })) ?? [];
	}
}
